import usePostData from '../../../../../hooks/postHook';

export const useCompleteInspection = ({ id }) => {
  const [{ data, body, isLoading, isError, error }, completeInspection] =
    usePostData(`office_parcel/${id}/inspection_done`);

  return { data, body, isLoading, isError, error, completeInspection };
};
